/**
 * Client utility functions
 */

/**
 * Generate a unique key for a client based on name and country
 * @param {Object} client - Client object
 * @returns {string} Unique client key
 */
export const getClientKey = (client) => {
  return `${client.client_name}-${client.country}`;
};

/**
 * Check if a client is external (manually locked)
 * @param {Object} client - Client object
 * @param {Function} isClientLocked - Function to check if client is locked
 * @returns {boolean} True if client is external
 */
export const isExternalClient = (client, isClientLocked) => {
  return isClientLocked(client);
};

/**
 * Check if a client belongs to a different manager
 * @param {Object} client - Client object
 * @param {string} portfolioType - Current portfolio type
 * @param {string} activeManager - Currently active manager
 * @returns {boolean} True if client is from different manager
 */
export const isFromDifferentManager = (client, portfolioType, activeManager) => {
  return portfolioType === 'manager' && activeManager && client.conference_manager !== activeManager;
};
